<div mat-dialog-content>
    <p class="back">{{message}}</p>
</div>